CreateOrgView = require 'views/organization/create-org-view'
PopOver = require 'views/lib/pop-over'
Util = require 'lib/util'
View = require 'view'
templates = require 'views/internal/templates'

module.exports = class NewBoardHelperAddOrgView extends View
  viewTitleKey: 'add an organization'

  events:
    'click .js-create-org': 'newOrg'

  render: ->
    view = @
    @$el.html(
      templates.fill(
        'popover_helper_new_board_add_org'
      )
    )
    @

  newOrg: (e) ->
    Util.stop(e)
    PopOver.pushView
      view: new CreateOrgView({ @model, @modelCache })



// WEBPACK FOOTER //
// ./app/scripts/views/board/new-board-helper-add-org-view.coffee